import { BasicRule } from "@/methods/rules.js";

class Rule extends BasicRule {
    constructor () {
        super();
    }
    checkPw2 () {
        return (rule, value, callback) => {
            if(value !== this.form.Password) {
                return callback(new Error("Two passwords are inconsistent."));
            }
            return callback();
        };
    }
}

export { Rule };